<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosExportCenter"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="taskType" :label="t('operate.ta0eas')">
              <a-select v-model:value="queryForm.taskType" allowClear :placeholder="t('common.pleaseSelect')">
                <a-select-option v-for="item in selectEXportEnum" :key="item.value" :value="item.value">{{
                  item.lang ? t(item.lang) : item.label
                }}</a-select-option>
              </a-select>
            </dc-form-item>
            <dc-form-item name="startTime" :label="t('common.createTime')">
              <cos-range-picker v-model:startTime="queryForm.startTime" v-model:endTime="queryForm.endTime" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === '$taskType'">
            <p>{{ text || '--' }}</p>
          </template>
          <template v-if="column.dataIndex === 'taskStatus'">
            <p>
              {{
                [
                  t('operate.ib0ffr'),
                  t('operate.vw3d2n'),
                  t('operate.0lkk5n'),
                  t('operate.jz7ejl'),
                  t('operate.eicn8l'),
                  t('operate.iq7ql8')
                ][record.taskStatus] || '--'
              }}
            </p>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button
                type="link"
                @click="addEdit(record)"
                v-if="vIfAndPermission(differentAppidDownload(), record.taskStatus === 1)"
                >{{ t('btn.download') }}</a-button
              >
              <a-button type="link" @click="deleteRow(record)" v-permission="differentAppidDelete()">{{
                t('btn.del')
              }}</a-button>
            </more-button>
          </template>
        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { useI18n } from 'vue-i18n'
import { reactive, ref, computed } from 'vue'
import { businessList, downloadGet, deleteExport } from '@/api/yuntuSales/exportCenter'
import { BigScoreBakcData } from '@/typings/api/gucangSale'
import getAppidType from './hooks/getAppIdType'
import getOption from './hooks/getOptions'
import { DcMessage } from '@dc-platform/dc-components'
import vIfAndPermission from '@/utils/ifAndPermission'

export default { name: 'list' }
</script>
<script setup lang="ts">
const { t } = useI18n()

// eslint-disable-next-line func-call-spacing
const editModalRef = ref<{ toggle: (row?: BigScoreBakcData) => void }>()
const { appIdData } = getAppidType()
const selectEXportEnum = computed(() => getOption(appIdData))
const tableRef = ref()
const queryForm = reactive({
  taskType: undefined,
  startTime: '',
  endTime: ''
})
const tableEXportEnum = computed(() => getOption())

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await businessList({ ...params, appId: appIdData.includes('cos_zbu') ? 'cos_zbu' : appIdData })
  callBack(res)
}
const differentAppidDelete = () => {
  const appIds = {
    cos_zbu_fbu: 'fbu_marketing_export_del_btn',
    cos_zbu_lbu: 'lbu_marketing_export_del_btn',
    cos_lbu: 'lbu_exportcenter_delete_btn',
    cos_fbu: 'fbu_exportcenter_delete_btn',
    cos_ofbu: 'ofbu_exportcenter_delete_btn'
  }
  return appIds[appIdData]
}
const differentAppidDownload = () => {
  const appIds = {
    cos_zbu_fbu: 'fbu_marketing_export_down_btn',
    cos_zbu_lbu: 'lbu_marketing_export_down_btn',
    cos_lbu: 'lbu_exportcenter_download_btn',
    cos_fbu: 'fbu_exportcenter_download_btn',
    cos_ofbu: 'ofbu_exportcenter_download_btn'
  }
  return appIds[appIdData]
}
const success = () => {
  tableRef.value.fetch()
}
const columns = computed(() => [
  { title: t('operate.82pppq'), dataIndex: 'fileName', minWidth: 250 },
  { title: t('operate.ta0eas'), dataIndex: 'taskType', minWidth: 190, dicData: tableEXportEnum.value },
  {
    title: t('operate.lbczwf'),
    dataIndex: 'taskStatus',
    minWidth: 150,
    format: (text: number) => {
      return [
        t('operate.ib0ffr'),
        t('operate.vw3d2n'),
        t('operate.0lkk5n'),
        t('operate.jz7ejl'),
        t('operate.eicn8l'),
        t('operate.iq7ql8')
      ][text]
    }
  },
  { title: t('common.createTime'), dataIndex: 'createTime', minWidth: 190 },
  { title: t('operate.tltno5'), dataIndex: 'updateTime', minWidth: 190 },
  { title: t('operate.m9u0pr'), dataIndex: 'createByName' },
  {
    title: t('common.action'),
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = async (_row?: BigScoreBakcData) => {
  try {
    const res = await downloadGet({ id: _row?.id })
    location.href = res.data.url
    DcMessage.success(t('operate.azs0kk'))
  } catch (error) {
    console.log('error: ', error)
  }
}
const deleteRow = (row: any) => {
  Modal.delete({
    name: row.fileName,
    onOk() {
      deleteExport({ id: row.id }).then(() => {
        DcMessage.success(t('operate.6k2ifb'))
        tableRef.value?.delFetch()
      })
    }
  })
}
</script>

<style scoped></style>
